<template>
  <div>
    <b-button
      :type="'is-primary ' + (addLoading ? 'is-loading' : '')"
      icon-left="plus"
      class="mb-3"
      @click="createCreditCardMandate()"
    >
      {{ $t("addMandate") }}
    </b-button>
    <b-table :data="tableData ? tableData : []" :hoverable="true" :focusable="false" :mobile-cards="true">
      <template slot-scope="props" @openRemoveModal="openRemoveModal">
        <b-table-column field="cardLabel" :label="$t('paymentMethod')">
          <img
            :src="getCardLabelSrc(props.row.details.cardLabel)"
            style="height: 1em; transform: scale(1.5) translateY(-8%); transform-origin: top left"
            class="mr-4"
          />
          &nbsp;****&nbsp;{{ props.row.details.cardNumber }}
        </b-table-column>

        <b-table-column field="cardHolder" :label="$t('cardHolder')">
          {{ props.row.details.cardHolder }}
        </b-table-column>

        <b-table-column field="expires" :label="$t('expires')">
          <span class="tag">
            {{ (new Date(props.row.details.cardExpiryDate).getMonth() + 1).toString().padStart(2) }}/{{
              new Date(props.row.details.cardExpiryDate).getFullYear().toString()
            }}
          </span>
        </b-table-column>

        <b-table-column field="mandateId" :label="$t('mandateId')">
          <span class="tag">
            {{ props.row.id }}
          </span>
        </b-table-column>

        <b-table-column :label="$t('actions')" numeric header-class="has-text-right">
          <span>
            <b-button type="is-small is-danger ml-2" icon-right="delete" @click="openDeleteModal(props.row.id)" />
          </span>
        </b-table-column>
      </template>

      <template slot="empty">
        <section class="section container">
          <div class="content has-text-grey has-text-centered">
            <p>
              <b-icon icon="emoticon-sad" size="is-large" />
            </p>
            <p>{{ $t("noMandates") }}</p>
          </div>
        </section>
        <template />
      </template>
    </b-table>
  </div>
</template>

<script>
import { functions } from "@/firebase";

export default {
  name: "MandatesTable",
  props: {
    mandates: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      addLoading: false,
    };
  },
  computed: {
    tableData() {
      return this.mandates;
    },
  },
  methods: {
    async createCreditCardMandate() {
      this.addLoading = true;
      try {
        let { data } = await functions.httpsCallable("MollieFirstPayment")({
          organizationId: this.$store.getters.getOrganizationId,
        });
        this.addLoading = false;
        window.location.href = data.checkoutUrl;
      } catch (error) {
        this.addLoading = false;
        this.$buefy.toast.open({
          duration: 5000,
          message: error.toString(),
          type: "is-danger",
        });
      }
    },
    getCardLabelSrc(cardLabel) {
      return `../assets/card-labels/${cardLabel.toLowerCase()}.svg`;
    },
    /**
     * @todo
     */
    openDeleteModal(mandateId) {
      console.log(mandateId);
      this.$buefy.dialog.confirm({
        title: this.$t("deleteMandate"),
        message: this.$t("deleteMandateInfo"),
        confirmText: this.$t("deleteMandate"),
        type: "is-danger",
        closeOnConfirm: false,
        hasIcon: true,
        onConfirm: async (str, component) => {
          console.log(str);
          console.log(component);
          try {
            await functions.httpsCallable("RevokeMollieMandate")({
              organizationId: this.$store.getters.getOrganizationId,
              mandateId: mandateId,
            });
            this.$buefy.toast.open(this.$t("mandateDeleted"));
          } catch (err) {
            this.$buefy.toast.open(err.toString());
          }
          component.close();
          return;
        },
      });
    },
  },
};
</script>

<style>
.table {
  width: 100%;
}
</style>
